module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-event-listener/~/babel-runtime/core-js/object/assign.js
 ** module id = 808
 ** module chunks = 3
 **/